import { Action } from '@ngrx/store';
import { DiagnosisTreanment, SearchModel } from '@nrwl/rx-models';

export enum ActionsTypes {
  LoadUsedDiagnosis = '[DiagnosisTreatments] Load used diagnosis',
  LoadUsedDiagnosisSuccess = '[DiagnosisTreatments] Load used diagnosis success',

  LoadUsedTreatments = '[DiagnosisTreatments] Load used treatments',
  LoadUsedTreatmentsSuccess = '[DiagnosisTreatments] Load used treatments success',

  LoadUsedSurgeons = '[DiagnosisTreatments] Load used surgeons',
  LoadUsedSurgeonsSuccess = '[DiagnosisTreatments] Load used surgeons success',

  LoadUsedVisitTypes = '[DiagnosisTreatments] Load used visit types',
  LoadUsedVisitTypesSuccess = '[DiagnosisTreatments] Load used visit types success',

  LoadUsedProcedureTypes = '[DiagnosisTreatments] Load used procedure types',
  LoadUsedProcedureTypesSuccess = '[DiagnosisTreatments] Load used procedure types success',

  LoadUsedBodyParts = '[DiagnosisTreatments] Load used body parts',
  LoadUsedBodyPartsSuccess = '[DiagnosisTreatments] Load used body parts success',

  LoadFormTitles = '[DiagnosisTreatments] Load Form Titles',
  LoadFormTitlesSuccess = '[DiagnosisTreatments] Load Form Titles success',

  LoadFormProviders = '[DiagnosisTreatments] Load Form Providers',
  LoadFormProvidersSuccess = '[DiagnosisTreatments] Load Form Providers success',

  Search = '[DiagnosisTreatments] search diagnosis',
  ResetSearch = '[DiagnosisTreatments] reset search diagnosis',

  SelectedSort = '[DiagnosisTreatments] selected sort',
  SelectedDiagnosis = '[DiagnosisTreatments] selected item diagnosis',
  SelectedTreatments = '[DiagnosisTreatments] selected item treatments',
  SelectedSurgeons = '[DiagnosisTreatments] selected item surgeons',

  DisableDiagnosis = '[DiagnosisTreatments] disable selected diagnosis',
  DisableTreatments = '[DiagnosisTreatments] disable selected treatments',
  DisableSurgeons = '[DiagnosisTreatments] disable selected surgeons',

  Error = '[DiagnosisTreatments] Error',

  LoadAreaImplants = '[DiagnosisTreatments] Load Area Implants',
  LoadAreaImplantsSuccess = '[DiagnosisTreatments] Load Area Implants Success',

  LoadImplantVolumes = '[DiagnosisTreatments] Load Implant Volumes',
  LoadImplantVolumesSuccess = '[DiagnosisTreatments] Load Implant Volumes Success',

  LoadImplantPlanes = '[DiagnosisTreatments] Load Implant Planes',
  LoadImplantPlanesSuccess = '[DiagnosisTreatments] Load Implant Planes Success',

  LoadBMIData = '[DiagnosisTreatments] Load BMI Data',
  LoadBMIDataSuccess = '[DiagnosisTreatments] Load BMI Data Success',

  LoadSkinToneData = '[DiagnosisTreatments] Load Skin Tone Data',
  LoadSkinToneDataSuccess = '[DiagnosisTreatments] Load Skin Tone Data Success',
}

// #region load diagnosis
export class LoadUsedDiagnosis implements Action {
  readonly type = ActionsTypes.LoadUsedDiagnosis;
}

export class LoadUsedDiagnosisSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedDiagnosisSuccess;
  constructor(public payload: DiagnosisTreanment[]) {}
}
// #endregion

// #region load treatments
export class LoadUsedTreatments implements Action {
  readonly type = ActionsTypes.LoadUsedTreatments;
}

export class LoadUsedTreatmentsSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedTreatmentsSuccess;
  constructor(public payload: DiagnosisTreanment[]) {}
}
// #endregion

// #region load surgeons
export class LoadUsedSurgeons implements Action {
  readonly type = ActionsTypes.LoadUsedSurgeons;
}

export class LoadUsedSurgeonsSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedSurgeonsSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load visit type
export class LoadUsedVisitTypes implements Action {
  readonly type = ActionsTypes.LoadUsedVisitTypes;
}

export class LoadUsedVisitTypesSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedVisitTypesSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load procedure type
export class LoadUsedProcedureTypes implements Action {
  readonly type = ActionsTypes.LoadUsedProcedureTypes;
}

export class LoadUsedProcedureTypesSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedProcedureTypesSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #region load surgeons
export class LoadUsedBodyParts implements Action {
  readonly type = ActionsTypes.LoadUsedBodyParts;
}

export class LoadUsedBodyPartsSuccess implements Action {
  readonly type = ActionsTypes.LoadUsedBodyPartsSuccess;
  constructor(public payload: { results: any[] }) {}
}
// #endregion

// #region load form titles
export class LoadFormTitles implements Action {
  readonly type = ActionsTypes.LoadFormTitles;
}

export class LoadFormTitlesSuccess implements Action {
  readonly type = ActionsTypes.LoadFormTitlesSuccess;
  constructor(public payload: any) {}
}
// #endregion

// #region load form providers
export class LoadFormProviders implements Action {
  readonly type = ActionsTypes.LoadFormProviders;
}

export class LoadFormProvidersSuccess implements Action {
  readonly type = ActionsTypes.LoadFormProvidersSuccess;
  constructor(public payload: any) {}
}
// #endregion

// #region search
export class Search implements Action {
  readonly type = ActionsTypes.Search;
  constructor(public payload: SearchModel) {}
}

export class ResetSearch implements Action {
  readonly type = ActionsTypes.ResetSearch;
}

// #endregion

// #region selected diagnosis, treatments, sort

export class SelectedSort implements Action {
  readonly type = ActionsTypes.SelectedSort;
  constructor(public payload: string) {}
}

export class SelectedDiagnosis implements Action {
  readonly type = ActionsTypes.SelectedDiagnosis;
  constructor(public payload: any) {}
}

export class SelectedTreatments implements Action {
  readonly type = ActionsTypes.SelectedTreatments;
  constructor(public payload: any) {}
}

export class SelectedSurgeons implements Action {
  readonly type = ActionsTypes.SelectedSurgeons;
  constructor(public payload: any) {}
}

// #endregion

// #region disable selected
export class DisableDiagnosis implements Action {
  readonly type = ActionsTypes.DisableDiagnosis;
}

export class DisableTreatments implements Action {
  readonly type = ActionsTypes.DisableTreatments;
}

export class DisableSurgeons implements Action {
  readonly type = ActionsTypes.DisableSurgeons;
}
// #endregion

// #region ERROR

export class Error implements Action {
  readonly type = ActionsTypes.Error;
  constructor(public payload: string) {}
}
// #endregion

// #region load area implants
export class LoadAreaImplants implements Action {
  readonly type = ActionsTypes.LoadAreaImplants;
}

export class LoadAreaImplantsSuccess implements Action {
  readonly type = ActionsTypes.LoadAreaImplantsSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load implant volumes
export class LoadImplantVolumes implements Action {
  readonly type = ActionsTypes.LoadImplantVolumes;
}

export class LoadImplantVolumesSuccess implements Action {
  readonly type = ActionsTypes.LoadImplantVolumesSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load implant planes
export class LoadImplantPlanes implements Action {
  readonly type = ActionsTypes.LoadImplantPlanes;
}

export class LoadImplantPlanesSuccess implements Action {
  readonly type = ActionsTypes.LoadImplantPlanesSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load BMI data
export class LoadBMIData implements Action {
  readonly type = ActionsTypes.LoadBMIData;
}

export class LoadBMIDataSuccess implements Action {
  readonly type = ActionsTypes.LoadBMIDataSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

// #region load Skin Tone data
export class LoadSkinToneData implements Action {
  readonly type = ActionsTypes.LoadSkinToneData;
}

export class LoadSkinToneDataSuccess implements Action {
  readonly type = ActionsTypes.LoadSkinToneDataSuccess;
  constructor(public payload: { results: DiagnosisTreanment[] }) {}
}
// #endregion

export type Actions =
  | LoadUsedDiagnosis
  | LoadUsedDiagnosisSuccess
  | LoadUsedTreatments
  | LoadUsedTreatmentsSuccess
  | LoadUsedSurgeons
  | LoadUsedSurgeonsSuccess
  | LoadUsedVisitTypes
  | LoadUsedVisitTypesSuccess
  | LoadUsedProcedureTypes
  | LoadUsedProcedureTypesSuccess
  | LoadUsedBodyParts
  | LoadUsedBodyPartsSuccess
  | LoadFormTitles
  | LoadFormTitlesSuccess
  | LoadFormProviders
  | LoadFormProvidersSuccess
  | Search
  | ResetSearch
  | SelectedSort
  | SelectedDiagnosis
  | SelectedTreatments
  | SelectedSurgeons
  | DisableDiagnosis
  | DisableTreatments
  | DisableSurgeons
  | Error
  | LoadAreaImplants
  | LoadAreaImplantsSuccess
  | LoadImplantVolumes
  | LoadImplantVolumesSuccess
  | LoadImplantPlanes
  | LoadImplantPlanesSuccess
  | LoadBMIData
  | LoadBMIDataSuccess
  | LoadSkinToneData
  | LoadSkinToneDataSuccess;
